export enum organizerStatus {
  AWAITING_VALIDATION = 'AWAITING_VALIDATION',
  DISABLED = 'DISABLED',
  IN_PROGRESS = 'IN_PROGRESS',
  LIVE = 'LIVE',
  VALIDATED = 'VALIDATED',
  SUSPENDED = 'SUSPENDED',
}
